import React, { useEffect } from 'react'
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import {Auth} from '../../Api/auth';

export default function AuthSession(props){

    const isAuthenticated=useIsAuthenticated();
    const {instance}=useMsal();

    const [state, setState] = React.useState({
        auth: false
      });
    
    useEffect(()=>{
        
        if (isAuthenticated) {

            Auth.authorizedFetch("/checkSessionExist",{},instance)
            .then(res => res.json())
            .then((result) => {
    
               
                if (result.statusCode==200){
                   
                    setState({...state, auth: true});
                  
                }
                else
                {
                    //wipe all local data so we can login again
                    Auth.logout();
                    window.location.reload();
                }
            })
            .catch((error)=>{
                Auth.logout();
                window.location.reload();
            
            })
    
        }

        
    },[isAuthenticated])

    return (state.auth && props.children)

}